import facebook from '@plone-collective/volto-authomatic/icons/facebook.svg';
import github from '@plone-collective/volto-authomatic/icons/github.svg';
import google from '@plone-collective/volto-authomatic/icons/google.svg';
import linkedin from '@plone-collective/volto-authomatic/icons/linkedin.svg';
import microsoft from '@plone-collective/volto-authomatic/icons/microsoft.svg';
import twitter from '@plone-collective/volto-authomatic/icons/twitter.svg';
import soe from './soe.svg';

const icons = {
  facebook: facebook,
  github: github,
  google: google,
  linkedin: linkedin,
  microsoft: microsoft,
  twitter: twitter,
  soe: soe,
};

export default icons;
